import { render } from "./InventoryMain.vue?vue&type=template&id=06b788b4&scoped=true"
import script from "./InventoryMain.vue?vue&type=script&lang=js"
export * from "./InventoryMain.vue?vue&type=script&lang=js"

import "./InventoryMain.vue?vue&type=style&index=0&id=06b788b4&scoped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b788b4"]])

export default __exports__